import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SolicitationRequest, SolicitCardRequest, UpdateSolicitationItemRequest, UpdateSolicitationRequest } from '../models/request/card-solicitation-request';
import { CardDataResponse, CardsLimitsResponse, CollaboratorWithoutCardResponse, SolicitationDetailResponse, SolicitationItemAddressResponse, SolicitationResponse, SolicitCardResponse } from '../models/response/card-solicitation-response';
import { ResponseBase } from '../models/response-base';

@Injectable({
  providedIn: 'root'
})
export class CardSolicitationService {

    private URL = environment.GATEWAY + 'cardSolicitation/';

    constructor(private http: HttpClient) { }

    cardsData(assignorGuid: string): Observable<ResponseBase<CardDataResponse>> {
        return this.http.get<ResponseBase<CardDataResponse>>(`${this.URL}cards/data/${assignorGuid}`);
    }

    cardsLimits(assignorGuid: string): Observable<ResponseBase<CardsLimitsResponse>> {
        return this.http.get<ResponseBase<CardsLimitsResponse>>(`${this.URL}cards/limits/${assignorGuid}`);
    }

    solicitations(solicitationRequest: SolicitationRequest, offset: number, limit: number): Observable<ResponseBase<SolicitationResponse>> {
        return this.http.post<ResponseBase<SolicitationResponse>>(`${this.URL}solicitations/offset/${offset}/limit/${limit}`, solicitationRequest);
    }

    solicitationItemAddress(solicitationId: number, solicitationItemId: number, assignorGuid: string): Observable<ResponseBase<SolicitationItemAddressResponse>> {
        return this.http.get<ResponseBase<SolicitationItemAddressResponse>>(`${this.URL}solicitation/${solicitationId}/item/${solicitationItemId}/assignor/${assignorGuid}`);
    }

    solicitationItens(solicitationId: number, assignorGuid: string): Observable<ResponseBase<SolicitationDetailResponse>> {
        let params = new HttpParams();
        params = params.append('assignorGuid', assignorGuid);
        return this.http.get<ResponseBase<SolicitationDetailResponse>>(`${this.URL}solicitation/${solicitationId}`, { params });
    }

    solicit(solicitCardRequest: SolicitCardRequest): Observable<ResponseBase<SolicitCardResponse>> {
        return this.http.post<ResponseBase<SolicitCardResponse>>(`${this.URL}solicit`, solicitCardRequest);
    }

    collaboratorsWithoutCard(assignorGuid: string, offset: number, limit: number, name: string, document: string): Observable<ResponseBase<CollaboratorWithoutCardResponse>> {
        let params = new HttpParams();
        params = params.append('name', name);
        params = params.append('document', document);
        return this.http.get<ResponseBase<CollaboratorWithoutCardResponse>>(`${this.URL}collaborators/without/card/assignor/${assignorGuid}/offset/${offset}/limit/${limit}`, { params });
    }

    updateSolicitation(updateSolicitationRequest: UpdateSolicitationRequest): Observable<ResponseBase<boolean>> {
        return this.http.put<ResponseBase<boolean>>(`${this.URL}update/solicitation`, updateSolicitationRequest);
    }

    updateSolicitationItem(updateSolicitationItemRequest: UpdateSolicitationItemRequest): Observable<ResponseBase<boolean>> {
        return this.http.put<ResponseBase<boolean>>(`${this.URL}update/solicitationitem`, updateSolicitationItemRequest);
    }
}
